import React from "react";
import "./MumbaiAirportPackage.css";

const puneToMumbai = [
  { name: "Sedan Cab", price: "₹2,800", icon: "🚘" },
  { name: "Ertiga Cab", price: "₹3,500", icon: "🚙" },
  { name: "Kia Carens", price: "₹4,500", icon: "🚗" },
  { name: "Innova Crysta", price: "₹5,500", icon: "🚐", popular: true },
];

const mumbaiToPune = [
  { name: "Sedan Cab", price: "₹2,800", icon: "🚘" },
  { name: "Ertiga Cab", price: "₹3,500", icon: "🚙" },
  { name: "Kia Carens", price: "₹4,500", icon: "🚗" },
  { name: "Innova Crysta", price: "₹5,500", icon: "🚐", popular: true },
];

export default function MumbaiAirportPackage() {
  return (
    <section className="airport-package">
      <div className="airport-container">

        {/* HEADER */}
        <div className="airport-header">
          <div className="airport-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="airport-logo"
            />
          </div>

          <div className="airport-header-content">
            <span className="airport-badge">
              PUNE ⇄ MUMBAI AIRPORT
            </span>

            <h1>
              Pune to Mumbai Airport
              <span> Cab Service</span>
            </h1>

            <p>
              Comfortable private airport cab service between Pune and
              Mumbai Airport with fixed package rates and toll tax included.
            </p>
          </div>
        </div>

        {/* ROUTES */}
        <div className="airport-route-bar">
          <div className="airport-route">
            <small>DROP</small>
            <strong>Pune → Mumbai Airport</strong>
          </div>

          <div className="route-divider">⇄</div>

          <div className="airport-route">
            <small>PICKUP</small>
            <strong>Mumbai Airport → Pune</strong>
          </div>
        </div>

        {/* SERVICE INFORMATION */}
        <div className="airport-info-grid">

          <div className="airport-info-card">
            <div className="info-icon">✈️</div>

            <div>
              <small>OUTSTATION AIRPORT TRANSFER</small>
              <h3>Pune to Mumbai Airport Drop</h3>
              <p>
                Direct Commercial Cab pickup from Pune and drop at
                Mumbai Airport.
              </p>
            </div>
          </div>

          <div className="airport-info-card">
            <div className="info-icon">🛬</div>

            <div>
              <small>AIRPORT PICKUP</small>
              <h3>Mumbai Airport to Pune Drop</h3>
              <p>
                Pickup from Mumbai Airport and comfortable Commercial
                cab drop anywhere in Pune.
              </p>
            </div>
          </div>

        </div>

        {/* =====================================
            PUNE TO MUMBAI AIRPORT
        ====================================== */}

        <div className="airport-pricing-section">

          <div className="airport-pricing-heading">
            <div>
              <span className="airport-mini-label">
                PUNE → MUMBAI AIRPORT
              </span>

              <h2>Airport Drop Cab Rates</h2>
            </div>

            <div className="included-pill">
              ✓ Toll Tax Included
            </div>
          </div>

          <div className="airport-vehicle-grid">

            {puneToMumbai.map((vehicle) => (
              <div
                className={`airport-vehicle-card ${
                  vehicle.popular ? "airport-popular" : ""
                }`}
                key={vehicle.name}
              >

                {vehicle.popular && (
                  <span className="airport-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="airport-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="airport-vehicle-details">
                  <h3>{vehicle.name}</h3>
                  <small>Airport Drop Package</small>
                </div>

                <div className="airport-price">
                  {vehicle.price}
                </div>

                <div className="airport-included">
                  ✓ Toll Included
                </div>

              </div>
            ))}

          </div>
        </div>

        {/* =====================================
            MUMBAI AIRPORT TO PUNE
        ====================================== */}

        <div className="airport-pricing-section return-section">

          <div className="airport-pricing-heading">
            <div>
              <span className="airport-mini-label">
                MUMBAI AIRPORT → PUNE
              </span>

              <h2>Airport Pickup Cab Rates</h2>
            </div>

            <div className="included-pill">
              ✓ Toll Tax Included
            </div>
          </div>

          <div className="airport-vehicle-grid">

            {mumbaiToPune.map((vehicle) => (
              <div
                className={`airport-vehicle-card ${
                  vehicle.popular ? "airport-popular" : ""
                }`}
                key={vehicle.name}
              >

                {vehicle.popular && (
                  <span className="airport-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="airport-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="airport-vehicle-details">
                  <h3>{vehicle.name}</h3>
                  <small>Airport Pickup Package</small>
                </div>

                <div className="airport-price">
                  {vehicle.price}
                </div>

                <div className="airport-included">
                  ✓ Toll Included
                </div>

              </div>
            ))}

          </div>

          {/* IMPORTANT NOTE */}
          <div className="airport-parking-note">

            <div className="parking-icon">P</div>

            <div>
              <strong>Airport Pickup Parking Extra</strong>

              <p>
                For Mumbai Airport to Pune pickup, toll tax is included
                in the package. Mumbai Airport pickup parking charges
                will be charged extra as applicable.
              </p>
            </div>

          </div>

        </div>

        {/* PACKAGE DETAILS */}
        <div className="airport-benefits">

          <div className="airport-benefit">
            <span>✓</span>
            <div>
              <strong>Commercial Cab</strong>
              <small>Dedicated vehicle for your journey</small>
            </div>
          </div>

          <div className="airport-benefit">
            <span>✓</span>
            <div>
              <strong>Toll Included</strong>
              <small>Included in listed package rates</small>
            </div>
          </div>

          <div className="airport-benefit">
            <span>✓</span>
            <div>
              <strong>Experienced Driver</strong>
              <small>Professional intercity drivers</small>
            </div>
          </div>

          <div className="airport-benefit">
            <span>✓</span>
            <div>
              <strong>Airport Transfer</strong>
              <small>Pune ⇄ Mumbai Airport</small>
            </div>
          </div>

        </div>

        {/* CTA */}
        <div className="airport-booking">

          <div>
            <span>GARUD CABS • PUNE</span>

            <h2>Book Pune ⇄ Mumbai Airport Cab</h2>

            <p>
              Commercial Cab • Fixed Package Rates • Toll Tax Included
            </p>
          </div>

          <a
            href="tel:+919970007784"
            className="airport-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}